import { z } from 'zod';
import { emailSchema, nameSchema, passwordSchema } from './common';

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(128),
  turnstileToken: z.string().max(4096).optional(),
});
export type LoginPayload = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  email: emailSchema,
  turnstileToken: z.string().max(4096).optional(),
});
export type ForgotPasswordPayload = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z.object({
  tokenHash: z.string().min(10).max(512),
  password: passwordSchema,
});
export type ResetPasswordPayload = z.infer<typeof resetPasswordSchema>;

export const acceptInviteSchema = z.object({
  token: z.string().min(10).max(512),
  firstName: nameSchema,
  lastName: nameSchema,
  password: passwordSchema,
  acceptTerms: z.literal(true),
});
export type AcceptInvitePayload = z.infer<typeof acceptInviteSchema>;

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(128),
  newPassword: passwordSchema,
});
export type ChangePasswordPayload = z.infer<typeof changePasswordSchema>;

export const updateProfileSchema = z.object({
  firstName: nameSchema,
  lastName: nameSchema,
  phone: z.string().max(20).nullable().optional(),
});
export type UpdateProfilePayload = z.infer<typeof updateProfileSchema>;
